import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class SpecificIPOUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.getSpecificIPODetails(req);
    }
}
export default SpecificIPOUseCase;
